import React, { Fragment, useState } from "react";
import Dashboard from "../Common/Components/Dashboard";
import MachineHealthGridWidget from "./MachineHealthGridWidget";
import MachineHealthChartWidget from "./MachineHealthChartWidget";
import Filters from "./MachineHealthFilters"
import format from "../Common/Util_methods/format";
import { Series } from "../Common/Types/types";
import { object } from "@amcharts/amcharts4/core";
import AdvancedLegendWidget from "./AdvancedLegendWidget";
import AdvancedLegendGrid from "./AdvancedLegendGrid";
import DashboardOptions from "../Common/Components/DashboardOptions";


const MachineHealthIndex = () =>{
    const [seriesFromGrid, updateSeriesFromGrid] = useState<Series>();
    const [legendSeries, updateLegendSeries] = useState<Series[]>([])

    const addSeriesHandler = (object:Series) =>{
        updateSeriesFromGrid(object)
    }

    const positionData = [
        {col:1,colSpan: 6, rowSpan:3},
        {col:1,colSpan: 6, rowSpan:3}
    ];

    const positionDataWithLegendWidget = [
        {col:1,colSpan: 4, rowSpan:3},
        {col:5,colSpan: 2, rowSpan:3},
        {col:1,colSpan: 6, rowSpan:3}
    ];

    const sidebarItems = [
        {title:"Filters",item:<Filters id="14" seriesFromGrid={seriesFromGrid}/>, expanded:true},
        {title: "Dashboard Options", item: < DashboardOptions />, expanded: true }
    ];

    return (
        <Fragment>
            <Dashboard positionData={positionDataWithLegendWidget} sidebarItems={sidebarItems}>
                <MachineHealthChartWidget id="machine-health-chart-widget" header="Interrupt Chart" legendSeries={legendSeries} updateLegendSeries={updateLegendSeries}/>
                <AdvancedLegendGrid id="advanced-legend-widget" header="Selected Series Grid" legendSeries={legendSeries} updateLegendSeries={updateLegendSeries}/>
                <MachineHealthGridWidget id="machine-health-grid-widget" header ="Interrupt Grid" addSeries={addSeriesHandler}/>
            </Dashboard>
        </Fragment>
    )
}

export default MachineHealthIndex;